import { returnErrors } from './errorAction';
import { LOGIN_USER, SIGNUP_USER, VERIFY_EMAIL, FORGOT_PASSWORD, RESET_PASSWORD, USER_DETAILS } from '../Types/types';
import { getApiCall, handle403Logout, postApiCall } from '../../utils/request';
import { getJobApiCall, postJobApiCall } from '../../utils/jobRequest';

export const userLogin = (login) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/login`, login);


        if (response?.status === 200) {
            return dispatch({ type: LOGIN_USER, payload: response.data });
        }
        // window.location.href = response.data.data?.role.includes('admin') ? '/manage-content' : '/my-learning'
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        let errorMsg = error.message;
        if (error.response?.data?.detail) {
            try {
                const detailObj = JSON.parse(error.response.data.detail);
                errorMsg = detailObj.message || errorMsg;
            } catch (e) { }
        } else if (error.response?.data?.responseMessages?.[0]?.message) {
            errorMsg = error.response.data.responseMessages[0].message;
        } else if (error.response?.data?.message) {
            errorMsg = error.response.data.message;
        }
        returnErrors(dispatch, errorMsg, error?.response?.status);
    }
}

export const userSignup = (signup) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`users/signup-with-otp`, signup);

        if (response?.status === 200) {
            const message = response?.data?.data?.message || response?.data?.message || 'Signup successful. OTP sent to email.';
            returnErrors(dispatch, message, response?.status)
            localStorage.setItem('userId', response.data?.userSignUp?.id || response?.data?.data?.userID)
            let obj = { ...signup, id: response.data?.userSignUp?.id || response?.data?.data?.userID }
            // await postJobApiCall(`user/signup-with-otp`, obj);
            return dispatch({ type: SIGNUP_USER });
        }
        else if (response?.status === 209) {
            return returnErrors(dispatch, "Email already registered.", response?.status);
        } else {
            return returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message || response?.data?.message || "Signup failed.", response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        let errorMsg = error.message;
        if (error.response?.data?.detail) {
            try {
                const detailObj = JSON.parse(error.response.data.detail);
                errorMsg = detailObj.message || errorMsg;
            } catch (e) {
                // Ignore parse error
            }
        } else if (error.response?.data?.responseMessages?.[0]?.message) {
            errorMsg = error.response.data.responseMessages[0].message;
        } else if (error.response?.data?.message) {
            errorMsg = error.response.data.message;
        }
        return returnErrors(dispatch, errorMsg, error?.response?.status);
    }
}

export const userSignupwithCoupon = (signup) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/coupon-signup`, signup);

        if (response?.status === 200) {
            returnErrors(dispatch, 'Signup successfully', response?.status)
            await dispatch({ type: SIGNUP_USER });
            return dispatch({ type: SIGNUP_USER });
        }
        // window.location.href = response.data.data?.role.includes('admin') ? '/manage-content' : '/my-learning'
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const resentEmail = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/re-send-verification`, obj);
        if (response?.status === 200) {
            returnErrors(dispatch, 'Email resend successfully', response?.status)
            // dispatch({ type: VERIFY_EMAIL });
        }
        else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const verifyEmail = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/verify-email?Id=${id}`);
        if (response?.status === 200) {
            returnErrors(dispatch, 'Email verified successfully', response?.status)
            localStorage.setItem('emailVerified', true);
            return dispatch({ type: VERIFY_EMAIL });
        }
        else {
            returnErrors(dispatch, "Please check link", response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, "Please check link", error?.response?.status);
    }
}

export const forgotPassword = (email) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/forget-password`, { emailId: email });
        if (response.status === 200) {
            dispatch({ type: FORGOT_PASSWORD, payload: response.data });
            returnErrors(dispatch, 'OTP is sent on your registered Email', response.status)
        }
        else {
            returnErrors(dispatch, response.data.message, response.status)
        }

    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const resetPasswords = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/reset-password`, obj);
        if (response.status === 200) {
            returnErrors(dispatch, 'Password has been successfully changed', response.status)
            return dispatch({ type: RESET_PASSWORD, payload: response.data });
        }
        else {
            returnErrors(dispatch, response.data.message, response.status)
        }

    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const verifyOtp = (obj) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`users/verify-otp`, obj);
        if (response?.status === 200 || response?.data?.success) {
            returnErrors(dispatch, response?.data?.message || 'OTP verified successfully', response?.status);
            if (response.data?.data?.userData) {
                return dispatch({ type: LOGIN_USER, payload: response.data.data.userData });
            } else if (response.data?.data) {
                return dispatch({ type: LOGIN_USER, payload: response.data.data });
            }
            return dispatch({ type: LOGIN_USER, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.message || response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error?.response?.data?.message || error?.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}

export const googleLoginWithCode = (code) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`users/google`, {
            code,
            redirect_uri: window.location.origin + '/auth/google/callback'
        });
        if (response?.status === 200) {
            return dispatch({ type: LOGIN_USER, payload: response.data.data });
        } else {
            const status = response?.response?.status || response?.status;
            const errorMsg = response?.response?.data?.detail || response?.data?.detail || response?.response?.data?.message || response?.data?.message || response?.response?.data?.responseMessages?.[0]?.message || "Google sign-in failed. Please try again with email and password.";
            returnErrors(dispatch, errorMsg, status);
            return { status, errorMsg };
        }
    } catch (error) {
        handle403Logout(error);
        const errorMsg = error?.response?.data?.detail || error?.response?.data?.message || error?.response?.data?.responseMessages?.[0]?.message || "Google sign-in failed. Please try again with email and password.";
        returnErrors(dispatch, errorMsg, error?.response?.status);
        return { status: error?.response?.status, errorMsg };
    }
}

export const microsoftLoginWithCode = (code) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`users/microsoft`, {
            code,
            redirect_uri: window.location.origin + '/auth/microsoft/callback'
        });
        if (response?.status === 200) {
            return dispatch({ type: LOGIN_USER, payload: response.data.data });
        } else {
            const status = response?.response?.status || response?.status;
            const errorMsg = response?.response?.data?.detail || response?.data?.detail || response?.response?.data?.message || response?.data?.message || response?.response?.data?.responseMessages?.[0]?.message || "Microsoft sign-in failed. Please try again with email and password.";
            returnErrors(dispatch, errorMsg, status);
            return { status, errorMsg };
        }
    } catch (error) {
        handle403Logout(error);
        const errorMsg = error?.response?.data?.detail || error?.response?.data?.message || error?.response?.data?.responseMessages?.[0]?.message || "Microsoft sign-in failed. Please try again with email and password.";
        returnErrors(dispatch, errorMsg, error?.response?.status);
        return { status: error?.response?.status, errorMsg };
    }
}

export const linkedInLoginWithCode = (code) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`users/linkedin`, {
            code,
            redirect_uri: window.location.origin + '/auth/linkedin/callback'
        });
        if (response?.status === 200) {
            return dispatch({ type: LOGIN_USER, payload: response.data.data });
        } else {
            const status = response?.response?.status || response?.status;
            const errorMsg = response?.response?.data?.detail || response?.data?.detail || response?.response?.data?.message || response?.data?.message || response?.response?.data?.responseMessages?.[0]?.message || "LinkedIn sign-in failed. Please try again with email and password.";
            returnErrors(dispatch, errorMsg, status);
            return { status, errorMsg };
        }
    } catch (error) {
        handle403Logout(error);
        const errorMsg = error?.response?.data?.detail || error?.response?.data?.message || error?.response?.data?.responseMessages?.[0]?.message || "LinkedIn sign-in failed. Please try again with email and password.";
        returnErrors(dispatch, errorMsg, error?.response?.status);
        return { status: error?.response?.status, errorMsg };
    }
}

export const googleLogin = (idToken) => async (dispatch) => {
    try {
        const response = await postJobApiCall(`users/google`, { id_token: idToken });
        if (response?.status === 200) {
            return dispatch({ type: LOGIN_USER, payload: response.data.data });
        } else {
            const status = response?.response?.status || response?.status;
            console.log("else error" + status);
            returnErrors(dispatch, response?.response?.data?.message || response?.data?.message || response?.response?.data?.responseMessages?.[0]?.message || "Email already exists. Can't proceed with Google signup.", status);
            return { status };
        }
    } catch (error) {
        handle403Logout(error);
        console.log("catch error");
        returnErrors(dispatch, error?.response?.data?.message || error?.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
        return { status: error?.response?.status };
    }
}

export const userDetails = () => async (dispatch) => {
    try {
        const response = await getJobApiCall(`auth/me`);
        if (response?.status === 200) {
            return dispatch({ type: USER_DETAILS, payload: response.data });
        }
        else {
            returnErrors(dispatch, response?.data?.message || response?.data?.responseMessages?.[0]?.message, response?.status);
        }
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error?.response?.data?.message || error?.response?.data?.responseMessages?.[0]?.message, error?.response?.status);
    }
}